<template>
    <div>
        <div class="flex flex-col gap-4 rounded-xl bg-grind p-8 text-white">
            <div class="text-xl font-bold">{{ heading }}</div>
            <div v-html="text"></div>
            <NuxtLink :to="linkUrl" class="btn-secondary-inverse text-center">{{
                linkLabel
            }}</NuxtLink>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps({
    heading: {
        type: String,
        default: '',
    },
    text: {
        type: String,
        default: '',
    },
    linkLabel: {
        type: String,
        default: '',
    },
    linkUrl: {
        type: String,
        default: '',
    },
});
</script>
